// extracted by mini-css-extract-plugin
export default {"modal":"modal__1yrvr","modal_wrapper":"modal_wrapper__dtG2H","modal_header":"modal_header__j4CoT","modal_body":"modal_body__3I-lM","modal_close":"modal_close__xtLJO"};